$(document).ready(function() {
  const bicDictionary  = $('#bicLabel').data('label');
  const ibanDictionary = $('#ibanLabel').data('label');
  const sepaCountries = $('#ibanLabel').data('sepa-countries');

  if (!bicDictionary) { return; }

  $('#bank_account_country').on('change', function() {
    if($(this).val() === 'CA') {
      $('#caBankAccount').removeClass('d-none');
    } else {
      $('#caBankAccount').addClass('d-none');
      $('#bank_account_institution_number, #bank_account_bank_name').val('');
    }

    var bicWording  = bicDictionary[$(this).val()];
    var ibanWording = ibanDictionary[$(this).val()];

    if (sepaCountries.includes($(this).val())) {
      $('#bicLabel').text((bicDictionary['sepa']) + ' *');
      $('#ibanLabel').text((ibanDictionary['sepa']) + ' *');
    } else {
      $('#bicLabel').text((bicWording || bicDictionary['other']) + ' *');
      $('#ibanLabel').text((ibanWording || ibanDictionary['other']) + ' *');
    }
  });
})
